var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":_vm.title}},[_c('p',[_vm._v("We can't find what you're looking for.")]),_c('p',[_vm._v(" Return to the "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("plant list")]),_vm._v(". ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }